import { render, staticRenderFns } from "./GoalStats.vue?vue&type=template&id=6145acdb&"
import script from "./GoalStats.vue?vue&type=script&lang=js&"
export * from "./GoalStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports